import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    type: "",
    find: "",
};

export const filterSlice = createSlice({
    name: "filter",
    initialState,
    reducers: {
        addType: (state, action) => {
            state.type = action.payload;
        },
        addFind: (state, action) => {
            state.find = action.payload;
        },
    },
});
export const { addType, addFind } = filterSlice.actions;
export default filterSlice.reducer;
